module.exports = __webpack_public_path__ + "media/assets/invitation-success-4a19560646d3e92177ce5643f8e71cc4.svg";